// Central public booking link config. All public CTAs, provider links, group
// registration links, and chatbot responses derive from this destination.
export const NEW_PORTAL_BOOKING_PATH = "/booking";
export const NEW_PORTAL_BOOKING_URL = "https://perspectivetherapy.com/booking";
export const CONTACT_URL = "/contact";
export const BOOKING_SYSTEM_STATUS = "new-portal-ready";

export const ACTIVE_BOOKING_URL = NEW_PORTAL_BOOKING_URL;
